var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Focusable } from '@/common/mixins/Focusable';
import PaymentsTable from '@/common/components/PaymentsTable.vue';
import EntityService from '@/common/services/EntityService';
import RouteService from "@/common/services/routeService";
import { Notification } from "@/common/services/notificationService";
import ExcelService from '@/common/services/ExcelService';
import PaymentTypeByTargetTable from '@/common/components/PaymentTypeByTargetTable.vue';
import { AidType } from '@/common/types/AidType';
import * as sorters from "@/common/types/PaymentRowSorters";
import SingleSelectAccessible from '@/common/components/SingleSelectAccessible.vue';
import _ from 'lodash';
var PaymentsView = /** @class */ (function (_super) {
    __extends(PaymentsView, _super);
    function PaymentsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedYear = -1;
        _this.paymentData = null;
        _this.tableRenderKey = "";
        return _this;
    }
    PaymentsView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.fetchPayments()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentsView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.delay(10)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2:
                        this.focusOnFirstTag("h1");
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentsView.prototype.fetchPayments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.entityService.getPaymentsData()];
                    case 1:
                        _a.paymentData = _b.sent();
                        if (this.availableYears.length > 0) {
                            this.selectedYear = this.availableYears[0].id;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.error(e_1);
                        this.paymentData = null;
                        error = this.$t("Payments.FetchFailed");
                        Notification.error(this, error);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PaymentsView.prototype, "entityService", {
        get: function () {
            return new EntityService();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "routeService", {
        get: function () {
            return new RouteService(this.$router);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "excelService", {
        get: function () {
            return new ExcelService();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "features", {
        get: function () {
            var config = this.$store.state.vuexPageModule.configuration;
            return config.featureConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOADING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "hasInvestmentTargets", {
        get: function () {
            return this.paymentData
                && this.paymentData.aidTargetPaymentData
                && this.paymentData.aidTargetPaymentData.some(function (x) { return x.aidType === AidType.B; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "aidTargetPayments", {
        get: function () {
            if (!this.paymentData || !this.paymentData.aidTargetPaymentData || this.paymentData.aidTargetPaymentData.length == 0)
                return null;
            var collection = this.paymentData.aidTargetPaymentData;
            return collection.sort(sorters.byTargetSorter);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "futurePayments", {
        get: function () {
            if (!this.paymentData || !this.paymentData.futurePayments || this.paymentData.futurePayments.length == 0)
                return null;
            var collection = this.paymentData.futurePayments;
            return collection.sort(sorters.futurePaymentSorter);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "hasPaymentHistoryItemsForSelectedYear", {
        get: function () {
            return this.yearlyPaymentHistory.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "yearlyPaymentHistory", {
        get: function () {
            var _this = this;
            if (!this.paymentHistory)
                return [];
            var collection = this.paymentHistory.filter(function (p) { return p.yearLocal == _this.selectedYear; });
            return collection.sort(sorters.historyPaymentSorter);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "availableYears", {
        /**
         * Available years payment history data. NOTE! Does not 'fill gaps' ie. if an organisation has history items for
         * years 2020 and 2018 then only 2020 and 2018 are included in the returned array.
         */
        get: function () {
            if (this.paymentHistory.length == 0)
                return [];
            var years = this.paymentHistory.map(function (payment) { return payment.yearLocal; });
            var uniqueSortedYears = _.uniq(years).sort(function (a, b) { return b - a; });
            var options = uniqueSortedYears.map(function (year) { return { id: year, name: year.toString() }; });
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "hasPaymentHistoryItems", {
        get: function () {
            return this.paymentHistory.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentsView.prototype, "paymentHistory", {
        get: function () {
            if (!this.paymentData || !this.paymentData.paymentHistory || this.paymentData.paymentHistory.length == 0)
                return [];
            return this.paymentData.paymentHistory.filter(function (p) { return p.yearLocal != null && p.yearLocal != undefined; });
        },
        enumerable: false,
        configurable: true
    });
    PaymentsView.prototype.generateExcel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fileName, e_2, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.downloadingFile = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        fileName = this.$t("Payments.PaymentHistory").toString();
                        return [4 /*yield*/, this.excelService.generatePaymentHistoryExcel(fileName)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        error = this.$t("Payments.ExcelError");
                        console.error(error, e_2);
                        Notification.error(this, error);
                        return [3 /*break*/, 4];
                    case 4:
                        this.downloadingFile = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PaymentsView.prototype, "downloadingFile", {
        get: function () {
            return this.$store.state.vuexPageModule.downloadingFile;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_DOWNLOADING_FILE", value);
        },
        enumerable: false,
        configurable: true
    });
    PaymentsView.prototype.cleanNewApplicationData = function () {
        if (this.hasPaymentHistoryItemsForSelectedYear) {
            this.tableRenderKey = Date();
        }
    };
    __decorate([
        Watch("selectedYear"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaymentsView.prototype, "cleanNewApplicationData", null);
    PaymentsView = __decorate([
        Component({
            name: 'PaymentsView',
            components: {
                PaymentsTable: PaymentsTable,
                PaymentTypeByTargetTable: PaymentTypeByTargetTable,
                SingleSelectAccessible: SingleSelectAccessible
            }
        })
    ], PaymentsView);
    return PaymentsView;
}(Mixins(Focusable)));
export default PaymentsView;
